import React from 'react';
import STRINGS from 'constants/strings';
import BiddingIcon from '@tradera/tradera-ui/icons/bidding.svg?jsx';

const OngoingAuctionsLink = () => (
    <a
        href="/my/active-items"
        rel="nofollow"
        aria-label={STRINGS.ONGOING_AUCTIONS}
        className="slim-header__menu-link px-3 d-flex align-items-center"
        data-ga-category="Header"
        data-ga-action="Navigation"
        data-ga-label={`${STRINGS.ONGOING_AUCTIONS}`}>
        <BiddingIcon className="icon icon-dark icon-md d-md-none d-block" />
    </a>
);

export default OngoingAuctionsLink;



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/components/site-header/ongoing-auctions-link.jsx